import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { AutoCompleteInput, Select, Input, Label, Checkbox, Button, MultiSelect } from "uxp/components";
import { DataSourcePropertyEditor } from "../../ui-props/DataSourceProperty";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../ui-props/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import jp from 'jsonpath'
import { executeAndBind, findAvailableFields, IDataSource, IDataSourceBinding } from "../../data-source-picker/datasource";

export const DropDownField: React.FunctionComponent<IUIFieldProps<IDropdownFieldProperty>> = (props) => {

	let { value, labelField, valueField, placeholder, onChange, binding, defaultText, useDataSource, allowSelectMultipleValues } = props?.fieldProps || {};
	let datasources: IDataSource[] = props.uiProps?.datasources || [];

	let [options, setOptions] = React.useState<any[]>([]);

	if (!labelField) labelField = 'label'
	if (!valueField) valueField = 'value'

	const defaultOptions = [
		{ [labelField]: 'Option 01', [valueField]: 'val1' },
		{ [labelField]: 'Option 02', [valueField]: 'val2' },
	]

	React.useEffect(() => {
		console.log('use data source ', useDataSource);

		if ((!props.mode || (props.mode != 'preview' && props.mode != 'thumbnail'))) {
			if (useDataSource && binding) {

				console.log('fields ', labelField, valueField)
				executeAndBind(props.fieldProps.uxpContext, binding, datasources, {}, props?.contextData)
					.then((opts: any[]) => {
						const updated = opts.map((op: any) => {
							return { [labelField]: op[labelField], [valueField]: op[valueField] }
						})
						setOptions(updated);
					})
					.catch(console.error);
			}
			else {
				const _options = props.fieldProps.options || []
				console.log('_opts ', _options);
				setOptions(_options)
			}
		}
		else {
			if (useDataSource) setOptions(defaultOptions)
			else setOptions(props.fieldProps.options || [])
		}
	}, [props.mode, props.fieldProps.options, props?.contextData]);

	const defaultOpt = { [labelField]: !!defaultText ? defaultText : 'Select an item', [valueField]: '' }
	const opts = allowSelectMultipleValues ? options : [defaultOpt, ...options]

	let Component = allowSelectMultipleValues ? MultiSelect : Select

	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
			<Component
				isValid={(opts && opts.length > 0) ? null : false}
				selected={value}
				onChange={(s) => { console.log(s, "S is this"); onChange(s) }}
				labelField={labelField}
				valueField={valueField}
				placeholder={placeholder}
				showEndOfContent={false}
				options={opts}
				selectAllOnLoad={props.fieldProps.selectAllOnLoad}
				wrapSelectedItemsToOneLine={true}
			/>
		</div>
	)
}

export interface IDropdownFieldProperty extends IBaseInputFieldProperty {
	placeholder: string;
	binding: IDataSourceBinding;
	labelField: string;
	valueField: string;
	defaultText: string;
	useDataSource?: boolean,
	options?: Array<{ label: string, value: string }>,
	fieldLabel: IFieldTitleProps;
	useLabelAsValue: boolean;
	allowSelectMultipleValues?: boolean
	selectAllOnLoad?: boolean
}

export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IDropdownFieldProperty>> = (props) => {

	let datasources: IDataSource[] = props.parentUIProps?.datasources || [];
	let pv = findAvailableFields(props.uiProps.binding, datasources);
	let _props = props.uiProps

	return <>
		<PropertyContainer>
			<PropertyContainerTitle>Dropdown</PropertyContainerTitle>

			<PropertyGroup>
				{/* <PropertyGroupTitle></PropertyGroupTitle> */}
				<Property>
					<PropertyTitle>Value</PropertyTitle>
					<AutoCompleteInput
						placeholder="Selected Value"
						value={props.uiProps.value || ''}
						onChange={s => props.onChange(Object.assign({}, props.uiProps, { value: s }))}
						options={[]}
					/>

					{props.uiProps.allowSelectMultipleValues && <Checkbox
						checked={props.uiProps.selectAllOnLoad}
						onChange={s => props.onChange(Object.assign({}, props.uiProps, { selectAllOnLoad: s }))}
						label="Select All on Load"
					/>}
				</Property>

				<Property>
					<PropertyTitle>Placeholder</PropertyTitle>
					<Input
						value={props.uiProps.placeholder || ''}
						onChange={s => props.onChange(Object.assign({}, props.uiProps, { placeholder: s }))}
					/>
				</Property>

				<Property>
					<PropertyTitle>Default Text</PropertyTitle>
					<Input
						value={props.uiProps.defaultText || ''}
						onChange={s => props.onChange(Object.assign({}, props.uiProps, { defaultText: s }))}
					/>
				</Property>
			</PropertyGroup>
			<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />

			<PropertyGroup>
				<PropertyGroupTitle>Options</PropertyGroupTitle>
				<Property>
					<Checkbox
						checked={_props.useDataSource}
						onChange={s => props.onChange(Object.assign({}, _props, { useDataSource: s }))}
						label="Get options form a data source"
						className="widget-designer-input"
					/>
				</Property>
				{_props.useDataSource ? <>
					<Property>
						<DataSourcePropertyEditor
							binding={_props.binding}
							context={props.uxpContext}
							onChange={(binding) => props.onChange(Object.assign({}, _props, { binding }))}
							onChangeAny={(p, v) => {
								props.onChangeAny(p, v);
							}}
							sources={datasources}
							target={'dictionary-array'}
							title='Data Source'
							contextData={props.contextData}
							className='uxp-designer-data-source-selector'
							designer={props.designer}
						/>
					</Property>

					<Property>
						<PropertyTitle>Label Field</PropertyTitle>
						<AutoCompleteInput
							options={pv}
							value={_props.labelField || ''}
							onChange={s => {
								let updated: any = { labelField: s }
								if (_props.useLabelAsValue) updated.valueField = s
								props.onChange(Object.assign({}, _props, updated))
							}}
						/>
					</Property>
					{
						!_props.useLabelAsValue && <Property>
							<PropertyTitle>Value Field</PropertyTitle>
							<AutoCompleteInput
								options={pv}
								value={_props.valueField || ''}
								onChange={s => props.onChange(Object.assign({}, _props, { valueField: s }))}
							/>
						</Property>
					}
					<Property>
						<Checkbox
							checked={_props.useLabelAsValue}
							onChange={s => {
								props.onChange(Object.assign({}, _props, {
									valueField: s ? _props.labelField : _props.valueField,
									useLabelAsValue: s
								}))
							}}
							label="Use label as value"
							className="widget-designer-input"
						/>
					</Property>
				</>
					:
					<>
						<Property>

							{_props?.options?.length &&
								<div className="wd-ui-property-group-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
									Options
								</div>
							}
							{!_props?.options?.length && <Label>No options were added</Label>}
							<div>

								{_props?.options?.map((s, i) => {

									return <div className="ui-field-config-item-row">
										<div className="column" style={{ width: !_props.useLabelAsValue ? '45%' : '90%' }}>
											<Input
												placeholder="Label"
												value={s?.label || ''}
												onChange={s => {
													if (_props.useLabelAsValue) {
														jp.apply(_props, `$.options[${i}].value`, () => (s))
													}

													jp.apply(_props, `$.options[${i}].label`, () => (s))
													props.onChange(_props)
												}}
											/>
										</div>
										{
											!_props.useLabelAsValue && <div className="column" style={{ width: '45%' }}>

												<Input
													placeholder="Value"
													value={s?.value || ''}
													onChange={s => {
														jp.apply(_props, `$.options[${i}].value`, () => (s))
														props.onChange(_props)
													}}
												/>
											</div>
										}

										<div className="column  action-column"
											onClick={() => {
												let options = _props?.options || []
												options.splice(i, 1)

												jp.apply(_props, `$.options`, () => (options))
												props.onChange(_props)
											}}
										>
											<FontAwesomeIcon icon={['fas', 'trash']} className='delete' />
										</div>
									</div>
								})}
								<Button
									className="new-option"
									title="Add New Option"
									icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
									iconPosition="right"
									onClick={() => {
										let options = _props?.options || []
										options.push({ label: '', value: '' })
										props.onChange(Object.assign({}, _props, { options }))
									}}
								/>

								<div style={{ marginTop: '15px' }}>
									<Checkbox
										checked={_props.useLabelAsValue}
										onChange={s => {
											if (s) {
												let options = _props?.options?.map((v) => ({ ...v, value: v?.label }))
												jp.apply(_props, `$.options`, () => (options))
											}

											props.onChange(Object.assign({}, _props, { useLabelAsValue: s }))
										}}
										label="Use label as value"
										className="widget-designer-input"
									/>
								</div>

							</div>

						</Property>

					</>
				}

			</PropertyGroup>

		</PropertyContainer>
	</>
}

registerUIField({
	id: 'dropdown',
	description: 'Dropdown List',
	field: DropDownField,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		binding: null,
		labelField: '',
		valueField: '',
		defaultText: 'Select',
		placeholder: 'Select an item',
		useDataSource: false,
		useLabelAsValue: true,
		fieldLabel: {
			label: 'Select an item',
		},
	},
	type: 'text'
});


export const MultipleSelect: React.FunctionComponent<IUIFieldProps<IDropdownFieldProperty>> = (props) => {

	let _props: IUIFieldProps<IDropdownFieldProperty> = { ...props, fieldProps: { ...props.fieldProps, allowSelectMultipleValues: true } }
	return <DropDownField
		{..._props}
	/>
}

registerUIField({
	id: 'multiple-select',
	description: 'Dropdown List (Multiple Values)',
	field: MultipleSelect,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		binding: null,
		labelField: '',
		valueField: '',
		defaultText: 'Select',
		placeholder: 'Select mulitple values',
		useDataSource: false,
		useLabelAsValue: true,
		fieldLabel: {
			label: 'Select mulitple values',
		},
		allowSelectMultipleValues: true
	},
	type: 'text'
});
